import React from 'react';
import {Alert, Button, Dialog, DialogActions, DialogContent, DialogTitle, Stack, Typography} from '@mui/material';

/**
 * DeleteReportDialog - Confirmation dialog for deleting a report
 *
 * @param {boolean} open - Whether the dialog is open
 * @param {function} onClose - Callback to close the dialog
 * @param {function} onConfirm - Callback when delete is confirmed
 * @param {boolean} deleting - Whether deletion is in progress
 * @param {string} title - The report title to display
 */
export default function DeleteReportDialog({open, onClose, onConfirm, deleting, title}) {
    return (
        <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
            <DialogTitle>Are you sure?</DialogTitle>
            <DialogContent>
                <Stack spacing={2}>
                    <Typography variant="body1">
                        This action will permanently delete
                        {title ? ` "${title}"` : ''}, all of its metadata, and associated user
                    </Typography>
                    <Alert severity={'warning'}>This cannot be undone.</Alert>
                </Stack>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} disabled={deleting}>
                    Cancel
                </Button>
                <Button color="error" onClick={onConfirm} disabled={deleting}>
                    {deleting ? 'Deleting…' : 'Delete'}
                </Button>
            </DialogActions>
        </Dialog>
    );
}
